// export const BASE_URL = "http://localhost:5000";
export const BASE_URL = "https://inotepad-9u0o.onrender.com";